export const PAYMENT_EVENTS = {
  BIN_PROCESS: "bin.process",
  INIT: "init",
  JWT_UPDATE: "jwt.update",
  SETUP_COMPLETE: "payments.setupComplete",
  VALIDATED: "payments.validated",
};
